/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadmitToFacility200ResponseData } from './ReadmitToFacility200ResponseData';
import {
    ReadmitToFacility200ResponseDataFromJSON,
    ReadmitToFacility200ResponseDataFromJSONTyped,
    ReadmitToFacility200ResponseDataToJSON,
    ReadmitToFacility200ResponseDataToJSONTyped,
} from './ReadmitToFacility200ResponseData';

/**
 * 
 * @export
 * @interface ReadmitToFacility200Response
 */
export interface ReadmitToFacility200Response {
    /**
     * 
     */
    data?: ReadmitToFacility200ResponseData;
}

/**
 * Check if a given object implements the ReadmitToFacility200Response interface.
 */
export function instanceOfReadmitToFacility200Response(value: object): value is ReadmitToFacility200Response {
    return true;
}

export function ReadmitToFacility200ResponseFromJSON(json: any): ReadmitToFacility200Response {
    return ReadmitToFacility200ResponseFromJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacility200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ReadmitToFacility200ResponseDataFromJSON(json['data']),
    };
}

export function ReadmitToFacility200ResponseToJSON(json: any): ReadmitToFacility200Response {
    return ReadmitToFacility200ResponseToJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseToJSONTyped(value?: ReadmitToFacility200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ReadmitToFacility200ResponseDataToJSON(value['data']),
    };
}

